
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[...uri]",
      function () {
        return require("private-next-pages/services/[...uri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[...uri]"])
      });
    }
  